<template>
  <div id="app">
    <!--<v-progress-circular v-if="mainLoadingShow" indeterminate v-bind:size="50" color="primary"></v-progress-circular>-->
    <rotate-square2 v-if="mainLoadingShow"></rotate-square2>
    <notifications/>
    <span class="title indigo--text" >Mohon menunggu... sedang merekontruksi aplikasi... </span>
  </div>
</template>

<script>
//  import loading from 'vue-full-loading'
  import Vue from 'vue'
  import router from './router'
  import App from '@/pages/PesertaUjian'
  import {store} from './store'
//  import Notify from './mixins/Notify'
  import {RotateSquare2} from 'vue-loading-spinner'

  export default {
    components: {
      RotateSquare2
    },
    data () {
      return {
        mainLoadingShow: false
      }
    },
    mounted: function () {
      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App)
      })
    }
  }
</script>

<style lang="stylus" scoped>
  @import './stylus/main';
</style>



// WEBPACK FOOTER //
// src_suopass/Boot.vue